/** @format */

import type { ReactNode } from 'react';
import { cn } from '@clarix/ui';

interface ActionBarProps {
  /** Left-aligned content: search, filters, view toggles, etc. */
  children?: ReactNode;
  /** Right-aligned content (pushed with `ml-auto`): primary buttons, export, etc. */
  right?: ReactNode;
  /** Render a bottom border (use when the ActionBar sits directly above the body). */
  bordered?: boolean;
  className?: string;
}

/**
 * The controls row — search, filters, view toggles, and primary action buttons.
 *
 * Fixed `h-12`, `shrink-0`, consistent `gap-2` and `px-5` so the toolbar lands
 * at the same height and rhythm on every page. Pair form controls/buttons at
 * `h-8` (size="xs") for a uniform control height across the app.
 */
export function ActionBar({ children, right, bordered = false, className }: ActionBarProps) {
  return (
    <div
      className={cn(
        'bg-surface flex h-11 shrink-0 items-center gap-2 px-5',
        bordered && 'border-border border-b',
        className,
      )}
    >
      {children}
      {right && <div className="ml-auto flex shrink-0 items-center gap-2">{right}</div>}
    </div>
  );
}
